import { useEffect } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LEGAL_CONTENT } from "@/lib/legalContent";

const LegalPage = () => {
  const { slug } = useParams();
  const content = LEGAL_CONTENT[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!content) return <Navigate to="/" replace />;

  return (
    <>
      <Navbar />
      <main data-testid="legal-page" className="bg-[#0A0A0A] min-h-screen pt-40 pb-28">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-neutral-400 hover:text-white transition-colors duration-200 mb-10">
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>

          <p className="text-neutral-500 text-xs tracking-[0.25em] font-semibold uppercase mb-4">Centro legal</p>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white tracking-tight mb-3">{content.title}</h1>
          <p className="text-neutral-500 text-sm mb-10">Última actualización: {content.updated}</p>

          <p className="text-neutral-300 text-[15px] leading-relaxed mb-12 border-l-2 border-white/15 pl-5">{content.intro}</p>

          <div className="flex flex-col gap-10">
            {content.sections.map((section, i) => (
              <div key={section.heading} data-testid={`legal-section-${i}`}>
                <h2 className="font-heading text-white text-lg md:text-xl font-bold mb-3">{section.heading}</h2>
                <div className="flex flex-col gap-3">
                  {section.body.map((p, j) => (
                    <p key={j} className="text-neutral-400 text-[15px] leading-relaxed">{p}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default LegalPage;
